import Tooltip from './classes/class-tooltip';

(() => {
  const nodes = document.querySelectorAll('[data-tooltip]');
  if (!nodes) return false;
  return [...nodes].map((node) => {
    const content = node.dataset.tooltip;
    const { position } = node.dataset;
    if (!content) return null;
    return new Tooltip(node, position, content);
  });
})();
